import React from "react";

import "./ConfigurationTab.css";

import { withTranslation } from "react-i18next";
import {
  Alert,
  Button,
  Col,
  Container,
  Dropdown,
  DropdownButton,
  Form,
  Row,
  Card
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import JsonViewerInstanceTemplates from "./jsonViewerInstanceTemplates/JsonViewerInstanceTemplates";
import JsonViewerVmConfiguration from "./jsonViewerInstanceTemplates/JsonViewerVmConfiguration";
import HclViewerTerraformConfiguration from "./jsonViewerInstanceTemplates/HclViewerTerraformConfiguration";
import SEBConfigurationFileUpload from "./jsonViewerInstanceTemplates/SEBConfigurationFileUpload";

class ConfigurationTab extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      configuration: {
        defaultValue: this.getPlaceholderConfiguration(),
        initValid: true,
        rule: ValidationHelper.isNonEmptyString,
      }
    };
    this.hiddenStaticFields = [
        "exam_type",
        "name",
        "expiration",
        "vm_server",
        "vm_user",
        "vm_password",
        "instance_id",
        "instance_token"
    ];
    this.state = {
      configurationInit: Date.now(),
      apiError: "",
      dialogApiError: "",
      validation: ValidationHelper.getValidation(this.validationDefinition),
    };

    this.getPlaceholderConfiguration = this.getPlaceholderConfiguration.bind(
      this
    );
    this.loadConfiguration = this.loadConfiguration.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handledDefaultConfigurationUpdate = this.handledDefaultConfigurationUpdate.bind(this);
    this.handleVmConfigurationUpdate = this.handleVmConfigurationUpdate.bind(this);
    this.handleTerraformConfigurationUpdate = this.handleTerraformConfigurationUpdate.bind(this);
    this.handleSEBConfigurationUpdate = this.handleSEBConfigurationUpdate.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  getPlaceholderConfiguration() {
    return "";
  }

  handleChange(event) {
    this.setState({
      validation: Object.assign(
        {},
        ValidationHelper.update(event, this.state.validation)
      ),
    });
  }

  handledDefaultConfigurationUpdate(configurationJSONString){
    const currentConfiguration = JSON.parse(this.state.validation.configuration.value);
    const updatedConfiguration = JSON.parse(configurationJSONString);
    this.hiddenStaticFields.forEach(f => {
      if (typeof currentConfiguration.static[f] !== "undefined"){
        updatedConfiguration.static[f] = currentConfiguration.static[f];
      }
    })

    if (typeof currentConfiguration.static["vm_configuration"] !== "undefined"){
      updatedConfiguration.static["vm_configuration"] = currentConfiguration.static["vm_configuration"];
    }
    if (typeof currentConfiguration.static["terraform"] !== "undefined"){
      updatedConfiguration.static["terraform"] = currentConfiguration.static["terraform"];
    }
    if (typeof currentConfiguration.static["seb_configuration"] !== "undefined"){
      updatedConfiguration.static["seb_configuration"] = currentConfiguration.static["seb_configuration"];
    }
    this.handleChange({
      target: {
        name: "configuration",
        value: JSON.stringify(updatedConfiguration),
      },
    })
  }


  handleVmConfigurationUpdate(configurationJSONString){
    const currentConfiguration = JSON.parse(this.state.validation.configuration.value);
    if (typeof currentConfiguration.static["vm_configuration"] !== "undefined"){
      currentConfiguration.static["vm_configuration"] = configurationJSONString;
    }
    this.handleChange({
      target: {
        name: "configuration",
        value: JSON.stringify(currentConfiguration),
      },
    })
  }

  handleTerraformConfigurationUpdate(configurationBase64String){
    const currentConfiguration = JSON.parse(this.state.validation.configuration.value);
    if (typeof currentConfiguration.static["terraform"] !== "undefined"){
      currentConfiguration.static["terraform"] = configurationBase64String;
    }
    this.handleChange({
      target: {
        name: "configuration",
        value: JSON.stringify(currentConfiguration),
      },
    })
  }

  handleSEBConfigurationUpdate(configurationBase64String){
    const currentConfiguration = JSON.parse(this.state.validation.configuration.value);
    if (typeof currentConfiguration.static["seb_configuration"] !== "undefined"){
      currentConfiguration.static["seb_configuration"] = configurationBase64String;
    }
    this.handleChange({
      target: {
        name: "configuration",
        value: JSON.stringify(currentConfiguration),
      },
    })
  }

  loadConfiguration(conf) {
    this.handleChange({
      target: {
        name: "configuration",
        value: conf.conf,
      },
    });
    this.setState({configurationInit: Date.now()});
  }

  refreshValidation() {
    const defaultConfiguration = this.props.instanceTemplate?.configuration
        ? atob(this.props.instanceTemplate?.configuration)
        : this.getPlaceholderConfiguration();

    const validationDefinition = {
      configuration: {
        defaultValue: defaultConfiguration,
        initValid: true,
        rule: ValidationHelper.isNonEmptyString,
      },
    };

    this.setState({
      configurationInit: Date.now(),
      validation: ValidationHelper.getValidation(
          this.props.instanceTemplate
              ? validationDefinition
              : this.validationDefinition
      ),
    });
  }

  componentDidMount() {
    this.refreshValidation();
  }

  async onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);

      await this.props.onSubmit(validatedData.configuration);
      this.refreshValidation();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.validation?.configuration.value) return;
    if (
      prevState.validation.configuration.value !==
      this.state.validation.configuration.value
    ) {
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Container className="pl-0 pr-0">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col className="title-container">
              <h4>
                {t("SingleInstanceTemplate.ConfigurationTab.ConfigurationFormats.Custom")}
              </h4>
            </Col>
            <Col className="d-flex flex-row-reverse">
              <Button
                className="btn btn-green save-button-margin"
                disabled={
                  !this.state.validation._isValid ||
                  !ValidationHelper.hasChanged(this.state.validation) ||
                  this.props.instanceTemplate?.isLocked ||
                  this.props.isSaving
                }
                onClick={this.onSubmit}
              >
                {t("InstanceTemplates.Modal.Form.Submit")}{" "}
                {this.props.isSaving && (
                  <FontAwesomeIcon icon={faCircleNotch} spin />
                )}
              </Button>
              <DropdownButton
                onClick={(event) => event.stopPropagation()}
                title={t("SingleInstanceTemplate.ConfigurationTab.Templates")}
                className="save-button-margin"
                style={{ marginRight: "1em" }}
              >
                {typeof this.props.configurationTemplates[this.props.instanceTemplate.type] !== "undefined" ?
                    (this.props.configurationTemplates[this.props.instanceTemplate.type]
                        .map((conf) => (
                            <Dropdown.Item onClick={() => this.loadConfiguration(conf)}>
                              {t("SingleInstanceTemplate.ConfigurationTab.Load")}:{" "}
                              {conf.name}
                            </Dropdown.Item>
                        ))) : ""}
              </DropdownButton>
            </Col>
          </Row>
          <Row className="row mt-3">
            {this.props.validationResult ? (
              <Col>
                <Alert variant="danger">
                  {this.props.validationResult
                    ?.split("Error:")
                    .map((err) => (err ? <pre>{err}</pre> : ""))}
                </Alert>
              </Col>
            ) : (
              ""
            )}
          </Row>
          <Row className="mt-1">
            <Col>
              <Form onSubmit={this.onSubmit}>
                <Form.Control
                  type="hidden"
                  isInvalid={!this.state.validation.configuration.isValid}
                />
                <Form.Control.Feedback type="invalid">
                  {t(
                    "InstanceTemplates.Modal.Form.ValidationError.Configuration"
                  )}
                </Form.Control.Feedback>
                <Row>
                  <Col>
                    <Card>
                      <Card.Body>
                        <Card.Title>
                          {t("SingleInstanceTemplate.ConfigurationTab.JsonViewerTitle")}
                        </Card.Title>
                        <p>{t(
                            "SingleInstanceTemplate.ConfigurationTab.JsonViewerDescription"
                        )}</p>
                        <JsonViewerInstanceTemplates
                            hiddenStaticFields={this.hiddenStaticFields}
                            contentInit={this.state.configurationInit}
                            content={this.state.validation.configuration.value}
                            handleUpdate={this.handledDefaultConfigurationUpdate}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col>
                    <Card>
                      <Card.Body>
                        <Card.Title>
                          {t("SingleInstanceTemplate.ConfigurationTab.SEBUploadTitle")}
                        </Card.Title>
                        <p>{t(
                            "SingleInstanceTemplate.ConfigurationTab.SEBUploadDescription"
                        )}</p>
                        <SEBConfigurationFileUpload
                            instanceTemplate={this.props.instanceTemplate}
                            contentInit={this.state.configurationInit}
                            content={this.state.validation.configuration.value}
                            handleUpdate={this.handleSEBConfigurationUpdate}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                {this.props.instanceTemplate?.type === 0 && (
                    <Row className="mt-3">
                      <Col>
                        <Card>
                          <Card.Body>
                            <Card.Title>
                              {t("SingleInstanceTemplate.ConfigurationTab.JsonViewerVmTitle")}
                            </Card.Title>
                            <p>{t(
                                "SingleInstanceTemplate.ConfigurationTab.JsonViewerVmDescription"
                            )}</p>
                            <JsonViewerVmConfiguration
                                contentInit={this.state.configurationInit}
                                content={this.state.validation.configuration.value}
                                handleUpdate={this.handleVmConfigurationUpdate}
                            />
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                )}
                {this.props.instanceTemplate?.type === 0 && (
                    <Row className="mt-3">
                      <Col>
                        <Card>
                          <Card.Body>
                            <Card.Title>
                              {t("SingleInstanceTemplate.ConfigurationTab.HclViewerTerraformTitle")}
                            </Card.Title>
                            <p>{t(
                                "SingleInstanceTemplate.ConfigurationTab.HclViewerTerraformDescription"
                            )}</p>
                            <HclViewerTerraformConfiguration
                                contentInit={this.state.configurationInit}
                                content={this.state.validation.configuration.value}
                                handleUpdate={this.handleTerraformConfigurationUpdate}
                            />
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                )}
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(ConfigurationTab);
